// extracted by mini-css-extract-plugin
module.exports = {"FAQSection":"FAQ_FAQSection__NOPsO"};